function onloadIntegration($page, event) {
    var title = "Process Automation and Microservices | ONEWEB Low-Code Development Platform";
    var description = "Process Automation and Microservices to integrate seamlessly with partners and legacy systems. Explore our Business Process Management, Dynamic Task Assignment, Worklist, and more.";
    addMeta(title, description);
}
function onloadBlog($page, event) {
    var title = "Articles, Opinions, Updates and News | ONEWEB Low-Code Development Platform";
    var description = "Profound insights, guidelines, daily updates and news you cannot miss from our ONEWEB team. Learn more how to transform all your digital visions into practices for real.";
    addMeta(title, description);
}
function onloadHealthcare($page, event) {
    var title = "Healthcare withLow-Code Platform | ONEWEB Low-Code Development Platform";
    var description = "Upgrade your healthcare system with ONEWEB Healthcare Solution. Explore how our digital system can enhance your healthcare efficiency.";
    addMeta(title, description);
}
function onloadSecurity($page, event) {
    var title = "Comprehensive Security Framework | ONEWEB Low-Code Development Platform";
    var description = "Comprehensive Security framework to support identity management, access control and cyber security, e.g., Identity Access Management and Application and Data Security";
    addMeta(title, description);
}
function onloadUsecase($page, event) {
    var title = "Explore What You Can Do With ONEWEB | All Our Use Cases Here and All";
    var description = "It's time to reimainge your digital platform strategy. Be it a banking process, digital insurance, human capital, health care, and more. ";
    addMeta(title, description);
}
function onloadBuildoncloud($page, event) {
    var title = "Build on Cloud Native Architecture | ONEWEB Low-Code Development Platform";
    var description = "Build on Cloud Native Architecture to provide interoperability and massive scalability. Explore our AppSpace, an intergrated platform where your application is born.";
    addMeta(title, description);
}
function onloadAgileatscal($page, event) {
    var title = "Agile at Scale with Kubernetes | ONEWEB Low-Code Development Platform";
    var description = "Within Kubernetes software can be deployed for the first time in a scale-out manner across Pods, and deployments can be scaled in or out at any time.";
    addMeta(title, description);
}
function onloadHumancapital($page, event) {
    var title = "Human Capital with Low-Code Platform | ONEWEB Low-Code Development Platform";
    var description = "The digital era is where people become the most important asset, not robot, lands, or even capital. Learn how to build an ultimate digital workplace for your people with ONEWEB.";
    addMeta(title, description);
}
function onloadFlexibleandFriendly($page, event) {
    var title = "Flexible and Friendly UX/UI Development Platform | ONEWEB Low-Code Development Platform";
    var description = "Flexible and friendly UX/UI development platform for Web and Mobile Experience all in one place. Create, build and deploy modernized Web & Mobile Apps within just a few days.";
    addMeta(title, description);
}
function onloadDigitalmarketing($page, event) {
    var title = "Digital Marketing with Low-Code Platform | ONEWEB Low-Code Development Platform";
    var description = "Kick start your digital disruptive journey with ONEWEB Digital Marketing Solution. Learn more how to apply ONEWEB with your digital marketing strategy.";
    addMeta(title, description);
}
var isName = false;
var isPhone = false;
var isLastName = false;
var isEmail = true;
var iscompany = false;
function validatePhoneNumber($page, event) {
	try {
    var re = /^[\+[0-9]?()[0-9](\S)(\d[0-9]{5,})$/;
    var phone = event.target.value;
    if (phone != '' || phone != null) {
      if (re.test(String(phone))) {
        $(".field-phone").removeClass("invalid-field");
        $("#error_phone").addClass("displaynone");
        isPhone = true;
      } else {
        isPhone = false;
        $(".field-phone").addClass("invalid-field");
        $("#error_phone").removeClass("displaynone");
      }
    }
  validateNotnull($page, event)    
  } catch (error) {
    console.error(error)
  }
}

function validatName($page, event) {
 try {
    var reg = /^[A-Za-z -]{2,}$/;
    var name = event.target.value;
    console.log(name);
    if (name != '' || name != null) {
      if (reg.test(String(name))) {
        isName = true;
        $(".field-name").removeClass("invalid-field");
        $("#error_name").addClass("displaynone");
      } else {
        isName = false;
        $(".field-name").addClass("invalid-field");
        $("#error_name").removeClass("displaynone");
      }
    }
   
  validateNotnull($page, event)
  }
  catch (error) {
    console.error(error);
  }
}

function validatLastName($page, event) {
	try {
    var reg = /^[A-Za-z -]{2,}$/;
    var lastname = event.target.value;
    console.log(lastname);
    if (lastname != '' || lastname != null) {
      if (reg.test(String(lastname))) {
        isLastName = true;
        $(".field-lastname").removeClass("invalid-field");
        $("#error_lastname").addClass("displaynone");
      } else {
        isLastName = false;
        $(".field-lastname").addClass("invalid-field");
        $("#error_lastname").removeClass("displaynone");
      }
    }
  validateNotnull($page, event)
  }
  catch (error) {
    console.error(error);
  }

 // validateNotnull($page, event)
}

function validatCompany($page, event) {
try {
    var reg = /^[a-zA-Z0-9\s,./-]{3,}$/;
    var company = event.target.value;
    console.log(company);
    if (company != '' || company != null) {
      if (reg.test(String(company))) {
        iscompany = true;
        $(".field-company").removeClass("invalid-field");
        $("#error_company").addClass("displaynone");
      } else {
        iscompany = false;
        $(".field-company").addClass("invalid-field");
        $("#error_company").removeClass("displaynone");
      }
    }
  validateNotnull($page, event)
  }
  catch (error) {
    console.error(error);
  }

  //validateNotnull($page, event)
}

function validateEmail($page, event) {
	 try {
    var reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var email = event.target.value;
    if (email != '' || email != null) {
      if (reg.test(String(email).toLowerCase())) {
        isEmail = true;
        $(".field-email").removeClass("invalid-field");
        $("#error_email").addClass("displaynone");
      } else {
        isEmail = false;
        $(".field-email").addClass("invalid-field");
        $("#error_email").removeClass("displaynone");
      }

    }

  validateNotnull($page, event)
  } catch (error) {
    console.error(error)
  }

}


function validateNotnull($page, event) {
  if(!isName||!isPhone||!isLastName||!isEmail||!iscompany){
    $('#button2').attr('disabled', true);
    $('#button2').css('background-color','#adadad')
  }else{
    $('#button2').removeAttr('disabled');
    $('#button2').css('background-color','#007bff')
  }

}


function onloadlelow($page, event) {
    var title = "Low-Code Development Platform: What Is It Really? What Can You Get from It?";
    var description = "What Is Lowcode Really? instead of writing hundreds lines of complex codes that is both time-consuming, a visual approach will help you easily navigate application development and a set of ready-made, drag-and-drop tools to help you create an app within just days or weeks";
    addMeta(title, description);
}
function onloadManufacturing($page, event) {
    var title = "Manufacturing with Low-Code Platform | ONEWEB Low-Code Development Platform";
    var description = "Address every area of your digitial manufacturing and excel above competitors with ONEWEB Digital Manufacturing, an ultimate solution to elevate your business to the next level.";
    addMeta(title, description);
}
function onloadFeatures($page, event) {
	var title="Low-Code Platform Features  | From Design to Realization";
	var description="Low-Code Development Platform Features | More than 1,000 pre-built components for you to select, assemble, and deploy at all once.";
	addMeta(title,description);
}

function onloadDigitaltransformation($page, event) {
    var title = "Digital Transformation Story for Non-Profit Organization | OneWeb";
    var description = "Higher costs and rising demand in social activities have driven non-profit organizations to relook at how digital technologies can enable them to build sustainable future. ";
    addMeta(title, description);
}

function onloadMythofmicroservices($page, event) {
    var title = "The Myth of Microservices | ONEWEB Low-Code Development Platform";
    var description = "Microservice emerges out of the Service Oriented Architecture concept within the past few year. Largely driven by major tech companies including Facebook, Netflix, Amazon, Twitter, etc.,";
    addMeta(title, description);
}
function onloadled($page, event) {
    var title = "5 Things to Look Out for When Choosing a Low-Code Development Platform";
    var description = "Look Out for When Choosing Lowcode platform; visual approach, velocity, security, scalability, customization. cloud-native architecture helps build and deploy scalable";
    addMeta(title, description);
}

function onloadHome($page, event) {
	var title="All-in-One Digital Creation Platform | ONEWEB Low-Code Development Platform";
  var description="All-in-One Digital Creation Platform | Realize your digital visions and develop your low-code and no-code platforms with less time, less work, less codes and less pains.";
  addMeta(title,description);
}

function addMeta(title,description){
  document.documentElement.lang = 'en';
  $('head').find("title").remove();
  $('head').find("meta[name=description]").remove();
  $('head').append('<title>'+title+'</title>');
  $('head').append('<meta name="description" content="'+description+'"/>');
}


function forceInitFbChat($page, event) {
	if (window.fbAsyncInit) {
		window.fbAsyncInit();
	}
}
function slideshowfooter($page, event) {
  let exist = document.querySelector('.sliders.active')
  console.log("event.target: ", event.target)
  console.log("Is exist? ", exist)
  let target = event.currentTarget;
  if (!$(target).hasClass('.sliders') && $(target).hasClass('slider-header')) {
    target = target.parentElement;
  }
  console.log("Target: ", target)
  if (exist) {
    console.log("Exist: removeClass")
    // $(exist).removeClass('active');
    footerSliderMenuSetNOTActive(exist);
    if (!target.isSameNode(exist)) {
      console.log("Not same node: addClass")
      // $(target).addClass('active');
      footerSliderMenuSetActive(target);
    }
  }
  else {
    console.log("Not exists: addClass")
    // $(target).addClass('active');
    footerSliderMenuSetActive(target);
  }
}

function footerSliderMenuSetActive(target) {
  let height = (target.querySelector('.ul-footer').childElementCount) * 46
  let body = target.querySelector('.slider-body')

  $(target).addClass('active');
  body.style.height = height + "px";
}

function footerSliderMenuSetNOTActive(target) {
  let body = target.querySelector('.slider-body')

  $(target).removeClass('active');
  body.style.height = "0px";
}

function navload($page) {
  var url = window.location.pathname;
  var urlName = $page.getPageName();
  // var arr = url.split('/');
  // var urlName = arr[arr.length-1];
  console.log('urlName:', urlName);
  switch (urlName.toLowerCase()) {
    case 'flexibleandfriendly':
    case 'integration':
    case 'buildoncloud':
    case 'security':
      urlName = 'home';
      break;
    case 'launchingappspace':
    case 'transforming':
    case 'fullyautomate':
    case 'mythofmicroservices':
    case 'accidentassistance':
    case 'digitaltransformation':
    case 'automatehealthcare':
    case 'agileatscal':
      urlName = 'blog'
      break;
    case 'banking':
    case 'digitalinsurance':
    case 'humancapital':
    case 'healthcare':
    case 'digitalmarketing':
    case 'digitaltransformation':
    case 'manufacturing':
      urlName = 'usecase'
      break;
  }
  console.log("URL::", urlName)
  setTimeout(function(){
    $("#"+(urlName).toLowerCase()).addClass('active');
  }, 100);
}


function hideSlideMenu($page, event) {
  console.log('clear slidemenu');
  $('[id=slidemenu]').removeClass('show');
  $('body').css({
    overflow: "",
    position: "",
    height: "",
    width: ""
  });
  $('#menunav').removeClass('croix');
}

function loadSlide() {
  console.log("loadSlide");
  var slideMenu = document.querySelector("#slidemenu");
  slideMenu.classList.remove("show");
}

function slidemenunav($page, event) {
  $('#slidemenu').toggleClass('show');
  if ($("#slidemenu").hasClass("show")) {
    $('#menunav').addClass('croix');
    $("body").css({
      overflow: "hidden",
      position: "fixed",
      height: "100%",
      width: "100%"
    });
  } else {
    $('#menunav').removeClass('croix');
    $("body").css({
      overflow: "",
      position: "",
      height: "",
      width: ""
    });
  }
  // menucroix($page, event)
}

function menucroix($page, event) {
  console.log('[menucroix]!');
  $('#menunav').toggleClass('croix');
}



var _slides, slide_dots, slide_indexs = 0, slide_interval;



function loadSlide_home() {
  console.log("LoadingSlide_Home -> initializing")
  slide_indexs =0;
  setTimeout(() => {
    _slides = $('#casestudyslide').find('.mock-box');
    console.log("Slidebar initial . . .", slide_indexs, _slides)
    if ($('#casestudyslide').find('.mock-box.show').length > 1) {
      $('#casestudyslide').find('.mock-box.show').last().removeClass('show');
    }
    slide_dots = $('#casestudyslide').find('.dots');
    console.log("LoadingSlide_Home -> time interval: ", slide_interval)
    console.log("LoadingSlide_Home -> Is time interval null? ", slide_interval == null)
    if (slide_interval != null) {
      resetSliderHomeInterval()
    } else {
      slide_interval = setInterval(onNext, 15000);
    }
    console.log("LoadingSlide_Home -> initialized time interval")
  }, 100)
}

function resetSliderHomeInterval() {
  console.log("Reseting slider_home time interval . . . ")
  clearInterval(slide_interval)
  slide_interval = setInterval(onNext, 5000);
}

function onNext(event) {
  if (event != undefined) {
    resetSliderHomeInterval()
  }
  let element = _slides[slide_indexs]
  toLeft(element, true)
  slide_indexs++;
  if ((slide_indexs) > (_slides.length - 1)) {
    slide_indexs = 0
  }
  for (let i = 0; i < slide_dots.length; i++) {
    slide_dots[i].setAttribute('class', 'dots')
  }
  slide_dots[slide_indexs].setAttribute('class', 'dots active')
  element = _slides[slide_indexs]
  element.style.transition = 'none'
  element.style.left = "100%"
  toLeft(element)
}

function onPrevious() {
  let element = _slides[slide_indexs];
  toRight(element, true)
  slide_indexs--;
  if ((slide_indexs) < 0) {
    slide_indexs = (_slides.length - 1)
  }
  for (let i = 0; i < slide_dots.length; i++) {
    slide_dots[i].setAttribute('class', 'dots')
  }
  slide_dots[slide_indexs].setAttribute('class', 'dots active')
  element = _slides[slide_indexs]
  element.style.transition = 'none'
  element.style.left = "-100%"
  toRight(_slides[slide_indexs])
}

function toLeft(_ele, isHide) {
  if (isHide) {
    _ele.style.left = "-100%"
    setTimeout(() => {
      _ele.setAttribute('class', 'mock-box');
    }, 500);
  } else {
    _ele.style.transition = 'all .5s'
    _ele.setAttribute('class', 'mock-box show');
    setTimeout(() => {
      _ele.style.left = "0"
    }, 100);
  }
}

function toRight(element, isHide) {
  if (isHide) {
    element.style.left = "100%"
    setTimeout(() => {
      element.setAttribute('class', 'mock-box');
    }, 500);
  } else {
    element.style.transition = 'all .5s'
    element.setAttribute('class', 'mock-box show');
    setTimeout(() => {
      element.style.left = "0"
    }, 100);
  }
}
// function setLeadId($page, event) {
// 	//$page.State.lid = $page.Store['SaveEmailLead'].SaveEmailOutput.leadId;
//   //$page.update();
// }

// function showEvent(){
//    setTimeout(()=>{
//  $('#MD_Event').modal('show');
//    },2000)
//  setTimeout(()=>{
//   $('#MD_Event').modal('hide');
//  },6000)
// }


// function _linkhome($page, event) {
//   gtag('event', 'page_view', {
//     'value':'home'
// });
// }


function ga_analytic($page, event) {
ga('create', 'UA-172826302-1', 'auto');
ga('create', 'UA-172848721-1', 'auto', { 'name': 'dev' });
ga('send', 'pageview', window.location.pathname);
ga('dev.send', 'pageview', window.location.pathname);;
}

function testload($page, event) {
	console.log("xxxxxxxxxxxx");
}

function onloadBanking($page, event) {
    var title = "Banking Process with ONEWEB Low-Code Development Platform | ONEWEB Low-Code Development Platform";
    var description = "Embed your customer experience and business purposes into your ultimate banking process and operations with ONEWEB's low-code development platform.";
    addMeta(title, description);
}
function onloadFullyautomate($page, event) {
    var title = "Fully automate business with BPM, RPA and ODM | ONEWEB Low-Code Development Platform";
    var description = "There comes a time when an automation is all what your business can ever want. Learn how to fully automate business with BPM, RPA, and ODM and gain competitive advantages.";
    addMeta(title, description);
}
function onloadDigitalinsurance($page, event) {
    var title = "Digital Insurance with Low-Code Platform | ONEWEB Low-Code Development Platform";
    var description = "The clock is ticking faster everyday for traditional insurfance providers. Overcome digital disruption and gain competitive advantages today with ONEWEB's Digitial Insurance solution.";
    addMeta(title, description);
}
function onloadAutomatehealthcare($page, event) {
    var title = "Automate healthcare compliance | ONEWEB Low-Code Development Platform";
    var description = "Operating under high-risk, data intensive environment, a successful healthcare business needs to handle and manage all sensitivities around patient information, and all other factors.";
    addMeta(title, description);
}
function onloadAutomatehealthcare($page, event) {
    var title = "Automate healthcare compliance | ONEWEB Low-Code Development Platform";
    var description = "Operating under high-risk, data intensive environment, a successful healthcare business needs to handle and manage all sensitivities around patient information, and all other factors.";
    addMeta(title, description);
}
function onloadTransforming($page, event) {
    var title = "Transforming to Low Code Delivery Model | ONEWEB Low-Code Development Platform";
    var description = "Since 2015, Low Code has become one of the hottest topics in software development, changing the way people approach software projects and bringing about enormous benefits to organizations.";
    addMeta(title, description);
}
function onloadLaunchingappspace($page, event) {
    var title = "Launching AppSpace, Your Ultimate End-to-End Application Lifecycle Management | ONEWEB";
    var description = "Introduce you AppSpace, our ultimate end-to-end application lifecycle management to help you excel above competitors and gain a sustainable competitive advantage.";
    addMeta(title, description);
}
function onloadDigitaltransformation($page, event) {
    var title = "Digital Transformation Story for Non-Profit Organization | OneWeb";
    var description = "Higher costs and rising demand in social activities have driven non-profit organizations to relook at how digital technologies can enable them to build sustainable future. ";
    addMeta(title, description);
}

